export default function MainPage({onStartQuizz}) {
  return (
    <div className="main-page">
      <h3 className="main-title">Meet Your New Best Friend!</h3>
      <p className="main-description">
        Take our fun quiz and discover which furry friends are your
        perfect match. We'll show you real adoptable pets with compatibility
        scores!
      </p>
      <button className="start-button" onClick={onStartQuizz}>Start Matching Process</button>
      <img
        className="hero-image"
        src="https://images.unsplash.com/photo-1450778869180-41d0601e046e?w=400&h=300&fit=crop"
        alt="Cute dog and cat sitting together"
      />
    </div>
  );
}